var map = {
	"./ion-accordion_2.entry.js": [
		7125,
		2076,
		7125
	],
	"./ion-action-sheet.entry.js": [
		23080,
		2076,
		3080
	],
	"./ion-alert.entry.js": [
		57880,
		2076,
		7880
	],
	"./ion-app_8.entry.js": [
		48970,
		2076,
		1529
	],
	"./ion-avatar_3.entry.js": [
		32235,
		2235
	],
	"./ion-back-button.entry.js": [
		89456,
		2076,
		9456
	],
	"./ion-backdrop.entry.js": [
		56950,
		6950
	],
	"./ion-breadcrumb_2.entry.js": [
		25560,
		2076,
		5560
	],
	"./ion-button_2.entry.js": [
		83277,
		3277
	],
	"./ion-card_5.entry.js": [
		57910,
		7910
	],
	"./ion-checkbox.entry.js": [
		3597,
		3597
	],
	"./ion-chip.entry.js": [
		88542,
		8542
	],
	"./ion-col_3.entry.js": [
		44754,
		2373
	],
	"./ion-datetime-button.entry.js": [
		80478,
		8182,
		478
	],
	"./ion-datetime_3.entry.js": [
		45767,
		8182,
		2076,
		5767
	],
	"./ion-fab_3.entry.js": [
		33853,
		2076,
		3853
	],
	"./ion-img.entry.js": [
		49929,
		9929
	],
	"./ion-infinite-scroll_2.entry.js": [
		29093,
		2076,
		682
	],
	"./ion-input.entry.js": [
		18498,
		2076,
		8498
	],
	"./ion-item-option_3.entry.js": [
		67567,
		2076,
		5796
	],
	"./ion-item_8.entry.js": [
		66040,
		2076,
		6040
	],
	"./ion-loading.entry.js": [
		28838,
		8838
	],
	"./ion-menu_3.entry.js": [
		54169,
		2076,
		4169
	],
	"./ion-modal.entry.js": [
		17731,
		2076,
		7731
	],
	"./ion-nav_2.entry.js": [
		6430,
		2076,
		6430
	],
	"./ion-picker-column-internal.entry.js": [
		90735,
		2076,
		735
	],
	"./ion-picker-internal.entry.js": [
		62962,
		2962
	],
	"./ion-popover.entry.js": [
		16039,
		2076,
		6039
	],
	"./ion-progress-bar.entry.js": [
		9499,
		9499
	],
	"./ion-radio_2.entry.js": [
		97064,
		7064
	],
	"./ion-range.entry.js": [
		81111,
		2076,
		1111
	],
	"./ion-refresher_2.entry.js": [
		53463,
		2076,
		492
	],
	"./ion-reorder_2.entry.js": [
		85724,
		2076,
		2591
	],
	"./ion-ripple-effect.entry.js": [
		98418,
		8418
	],
	"./ion-route_4.entry.js": [
		1396,
		1396
	],
	"./ion-searchbar.entry.js": [
		54003,
		2076,
		4003
	],
	"./ion-segment_2.entry.js": [
		14754,
		2076,
		4754
	],
	"./ion-select_3.entry.js": [
		89814,
		9814
	],
	"./ion-slide_2.entry.js": [
		40970,
		970
	],
	"./ion-spinner.entry.js": [
		83667,
		2076,
		3667
	],
	"./ion-split-pane.entry.js": [
		57161,
		7161
	],
	"./ion-tab-bar_2.entry.js": [
		98016,
		2076,
		8016
	],
	"./ion-tab_2.entry.js": [
		93064,
		2076,
		3064
	],
	"./ion-text.entry.js": [
		76899,
		6899
	],
	"./ion-textarea.entry.js": [
		25922,
		5922
	],
	"./ion-toast.entry.js": [
		55701,
		5701
	],
	"./ion-toggle.entry.js": [
		20364,
		2076,
		364
	],
	"./ion-virtual-scroll.entry.js": [
		12287,
		2287
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 88996;
module.exports = webpackAsyncContext;